import { ReactNode } from 'react';
import { StyleSheet } from 'react-native';

import { ListItemGroup, ListItemRadioWithChildren, RadioGroup, YStack, tokens } from '@fhs/ui';
import { StyledAddNewCreditCardIcon } from '@fhs-legacy/frontend/src/components/payment-method/styled';
import { PaymentMethodAddNewItemOption } from '@fhs-legacy/frontend/src/components/payment-method-add-new-item-option';
import PaymentMethodOption from '@fhs-legacy/frontend/src/components/payment-method-option';
import { IPaymentMethod } from '@fhs-legacy/frontend/src/state/payment/types';

type PaymentMethodSelectProps = {
  paymentMethods: IPaymentMethod[];
  selectedOption: string;
  customHeader?: ReactNode;
  onSelectOption: (value: string) => void;
};

export const PaymentMethodSelect = ({
  customHeader,
  paymentMethods,
  selectedOption,
  onSelectOption,
}: PaymentMethodSelectProps) => {
  return (
    <RadioGroup value={selectedOption} onChange={onSelectOption}>
      <ListItemGroup
        items={paymentMethods.map(method => ({
          id: method.accountIdentifier ?? undefined,
          render: listItemProps => (
            <>
              {customHeader && listItemProps.isFirstItem && (
                <YStack style={styles.headerContainer}>{customHeader}</YStack>
              )}
              <ListItemRadioWithChildren
                value={method.accountIdentifier ?? ''}
                label={method.accountIdentifier ?? ''}
                isFirstItem={customHeader ? listItemProps.isFirstItem : false}
                isLastItem={false}
                indicatorSize="sm"
              >
                <PaymentMethodOption method={method} onPress={undefined} hideDeleteIcon />
              </ListItemRadioWithChildren>
              {listItemProps.isLastItem && (
                <ListItemRadioWithChildren
                  value="newCard"
                  label="newCard"
                  isFirstItem={false}
                  isLastItem
                  indicatorSize="sm"
                >
                  <PaymentMethodAddNewItemOption
                    text="Add New Card"
                    Icon={<StyledAddNewCreditCardIcon />}
                    onPress={() => {}} // TODO: handle this when integrating with API
                  />
                </ListItemRadioWithChildren>
              )}
            </>
          ),
        }))}
      />
    </RadioGroup>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flex: 1,
    width: '100%',
    padding: 16,
    borderBottomWidth: 1,
    borderColor: tokens.colors.$black10,
  },
});
